<template>
  <div
    v-on="$listeners"
    class="btn-with-badge__wrapper">
    <slot />
  </div>
</template>
<script>
export default {
  name: 'ButtonWithBadgeWrapper',
};
</script>
<style scoped>
.btn-with-badge__wrapper:hover {
  cursor: pointer;
}
</style>
